<template>
  <div
    class="m-content"
    :style="param === 'themes' || param === 'segmentations' ? 'padding:0;': ''"
  >
    <div class="m-portlet m-portlet--mobile">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text">{{ tableName }}</h3>
          </div>
        </div>
        <div class="m-portlet__head-tools">
          <div
            id="m_quicksearch"
            m-quicksearch-mode="default"
            class="m-stack__item m-stack__item--middle m-dropdown m-dropdown--arrow m-dropdown--large m-dropdown--mobile-full-width m-dropdown--align-right m-dropdown--skin-light m-header-search m-header-search--expandable m-header-search--skin-light"
          >
            <form class="m-header-search__form">
              <div class="m-header-search__wrapper">
                <span id="m_quicksearch_search" class="m-header-search__icon-search">
                  <i class="flaticon-search"></i>
                </span>
                <span class="m-header-search__input-wrapper">
                  <input
                    v-model="keywords"
                    @keydown.enter.stop.prevent
                    autocomplete="off"
                    type="text"
                    name="q"
                    value
                    :placeholder="labels.search"
                    id="m_quicksearch_input"
                    class="m-header-search__input"
                  />
                </span>
                <span id="m_quicksearch_close" class="m-header-search__icon-close">
                  <i class="la la-remove"></i>
                </span>
                <span id="m_quicksearch_cancel" class="m-header-search__icon-cancel">
                  <i class="la la-remove"></i>
                </span>
              </div>
            </form>
          </div>
          <ul class="m-portlet__nav" v-if="fullProductManagementAccess">
            <li class="m-portlet__nav-item">
              <a
                @click.prevent.stop="toggleCRUDMode('create')"
                href="#"
                class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon"
              >
                <span>
                  <i class="la la-plus"></i>
                  <span>{{ labels['new_record'] }}</span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="m-portlet__body">
        <div
          id="kt_table_1_wrapper"
          class="dataTables_wrapper dt-bootstrap4 no-footer"
          v-if="dataFields"
        >
          <div class="row">
            <div class="col-sm-12">
              <div class="dataTables_scroll">
                <div
                  class="dataTables_scrollBody"
                  style="position: relative; overflow: auto; width: 100%; max-height: 70vh; overflow-x: hidden;"
                >
                  <table
                    class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer sticky"
                    id="kt_table_1"
                    role="grid"
                    aria-describedby="kt_table_1_info"
                  >
                    <thead class="thead-light">
                      <tr role="row" style="height: 10px;">
                        <th
                          v-for="key in dataFields.columns"
                          :key="'sorting_' + key"
                          class="table-head"
                        >{{ columnHeader(key)|capitalize }}</th>
                        <th v-if="param === 'themes'"> {{ labels['file_link_to_object_theme'] }}</th>
                        <th
                          class="table-head"
                          rowspan="1"
                          colspan="1"
                          style="width:64px;"
                          aria-label="Actions"
                          v-if="fullProductManagementAccess"
                        >{{ labels.actions }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="crudMode === 'create'" id="extendedForm_create">
                        <td :colspan="dataKeysLength + 1">
                          <!-- Form for external resources here -->
                          <SimpleForm
                            v-if="dataFields.externalResource"
                            :param="param"
                            :itemIdName="itemIdName"
                            index="new"
                            ref="crudForm"
                          />

                          <!-- Else, normal form-->
                          <edit-crud
                            :param="param"
                            :itemIdName="itemIdName"
                            index="new"
                            ref="crudForm"
                            v-else
                          ></edit-crud>
                        </td>
                      </tr>
                      <template v-for="(data, index) in filteredList">
                        <tr
                          role="row"
                          :key="index"
                          :id="'crudRow_' + (index+ 1)"
                          :class="index % 2 === 0 ? 'even' : 'odd'"
                        >
                          <template v-for="(info, key) in dataFields" v-if="renderColumn(key)">
                            <product-row
                              :data="data[key]"
                              :key="'product_'+ key"
                              v-if="data[key] && (dataFields[key] === 'products' || dataFields[key][0] === 'products')"
                            ></product-row>
                            <td :key="key" v-else >
                              <div
                                v-html="showCRUDInfo(data, key)"
                                style="max-width:fit-content;"
                              ></div>
                            </td>
                          </template>
                          <td v-if="param === 'themes'">
                              <show-files-link-to-object type="themes" :object-id="data.theme_id" :withDelete="false" v-if="data.theme_id"/>
                            </td>
                          <td nowrap class="crud-actions" v-if="fullProductManagementAccess">
                            <a
                              @click.prevent.stop="toggleCRUDMode(index+1)"
                              href="#"
                              style="color:black;"
                              class="btn btn-md btn-clean btn-icon btn-icon-md"
                            >
                              <i class="fa flaticon-edit"></i>
                            </a>
                            <!-- <a
                              v-if="canDeleteCRUD(data)"
                              @click.prevent="deleteItem(data, index)"
                              href="#"
                              style="color:red;"
                              class="btn btn-md btn-clean btn-icon btn-icon-md"
                            >
                              <i class="fa flaticon-circle"></i>
                            </a> -->
                            <!-- <div v-else class="delete-disabled">
                              <a
                                href="#"
                                @click.prevent
                                class="btn btn-md btn-clean btn-icon btn-icon-md"
                                style="color:#74788d;"
                              >
                                <i class="fa flaticon-circle"></i>
                              </a>
                              <span
                                class="custom-tooltip custom-tooltip btn m-btn--air btn-danger"
                              >{{ labels.cannot_delete_segmentation }}</span>
                            </div> -->
                          </td>
                        </tr>
                        <tr :key="'edit_' + index" :id="'extendedForm_' + (index+ 1)">
                          <td :colspan="dataKeysLength + 1" v-if="crudMode === index + 1">
                            <!-- Form for external resources here -->
                            <SimpleForm
                              v-if="dataFields.externalResource"
                              ref="crudForm"
                              :param="param"
                              :itemIdName="itemIdName"
                              :data="data"
                              :index="index"
                              :key="'edit_'+index"
                            />

                            <!-- Else, normal form-->
                            <edit-crud
                              ref="crudForm"
                              :param="param"
                              :itemIdName="itemIdName"
                              :data="data"
                              :index="index"
                              :key="'edit_'+index"
                              v-else
                            ></edit-crud>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import { HTTP } from '../../assets/js/axiosConfig';
import { CRUDDelete } from '../../assets/js/CRUDFirestore';
// Mixins
import Uuid from '../../assets/js/mixins';
import GetCRUDName from '../../assets/js/mixins';
import SendPostRequest from '../../assets/js/mixins';
import AlertAction from '../../assets/js/mixins';
import SweetAlert from '../../assets/js/mixins';
import UpdateFirestore from '../../assets/js/mixins';
// Components
import EditCrud from './ExtendedInfo';
import SimpleForm from './SimpleForm';
import ProductRow from './ProductRow';
// JSON
import dataFields from '../../data/schemas/CRUD_data_structure.json';
import { firebase } from '../../assets/js/firebase';
import ShowFilesLinkToObject from '../Upload/ShowFilesLinkToObject.vue';

const timer = 2000;

export default {
  name: 'DataTable',
  mixins: [
    Uuid,
    GetCRUDName,
    SendPostRequest,
    AlertAction,
    SweetAlert,
    UpdateFirestore,
  ],
  components: {
    EditCrud,
    ProductRow,
    SimpleForm,
    ShowFilesLinkToObject,
  },
  data() {
    return {
      param: '',
      source: null, // axios cancellation source token
      keywords: '',
    };
  },
  watch: {
    '$route.params.name': function (value) {
      // Watch when param changes
      this.resourceSwitch(value);
    },
  },
  computed: {
    ...mapState({
      labels: (store) => store.labels,
      roles: (store) => store.roles,
      crudMode: (store) => store.crudData.crudMode,
      crudData: (store) => store.crudData.cruds,
      cmsResources: (store) => store.crudData.cmsResources,
    }),
    ...mapGetters(['fullProductManagementAccess', 'getName']),
    tableName() {
      // Remove "_" characters and transform to uppercase
      return this.labels.resources[this.param];
    },
    itemIdName() {
      return this.param ? this.getCRUDName(this.param) : null;
    },
    dataList() {
      if (this.param === 'segmentations') {
        // Return only parent segmentations
        return this.crudData[this.param].filter((segmentation) => {
          if (!segmentation.hasOwnProperty('segmentation_parent')) {
            this.segmentationHasChildren(segmentation.segmentation_id)
              ? this.$set(segmentation, 'hasChildren', true)
              : this.$set(segmentation, 'hasChildren', false);
            return true;
          }
        });
      }
      return this.dataFields.externalResource
        ? this.cmsResources[this.param]
        : this.crudData[this.param];
    },
    filteredList() {
      if (this.keywords) {
        if (this.dataFields.hasOwnProperty('orderBy')) {
          return this.orderBy(
            this.dataList,
            {
              key: this.dataFields.orderBy,
              resource: this.dataFields[this.dataFields.orderBy],
            },
            { key: this.dataFields.orderBy2 },
          ).filter((param) => {
            const name = param.name.toLowerCase();
            if (name.indexOf(this.keywords.toLowerCase()) !== -1) {
              return param;
            }
          });
        }
        return this.dataList.filter((param) => {
          const name = param.name.toLowerCase();
          if (name.indexOf(this.keywords.toLowerCase()) !== -1) {
            return param;
          }
        });
      }
      return this.dataFields.hasOwnProperty('orderBy')
        ? this.orderBy(
          this.dataList,
          {
            key: this.dataFields.orderBy,
            resource: this.dataFields[this.dataFields.orderBy],
          },
          { key: this.dataFields.orderBy2 },
        )
        : this.dataList;
    },
    dataFields() {
      return dataFields[this.param];
    },
    dataKeysLength() {
      const keys = Object.keys(this.dataFields);
      return keys.length;
    },
  },
  methods: {
    ...mapActions([
      'toggleCRUDMode',
      'products/productSegmentAction',
      'products/setFormModalData',
    ]),
    renderColumn(key) {
      return this.dataFields.columns.indexOf(key) !== -1;
    },
    showCRUDInfo(data, key) {
      if (
        this.dataFields[key] === 'string'
        || this.dataFields[key] === 'longtext'
        || this.dataFields[key] === 'countries'
      ) {
        return data[key];
      } if (this.dataFields[key] === 'link') {
        return data[key]
          ? `<a href="${data[key]}" target="_blank" style="color:#17a2b8;">${data[key]}</a>`
          : '';
      } if (
        this.dataFields[key] !== 'string'
        && this.dataFields[key] !== 'longtext'
        && typeof this.dataFields[key] === 'string'
        && data[key]
      ) {
        return this.getNameById(data[key], this.dataFields[key]);
      } if (Array.isArray(this.dataFields[key]) && data[key]) {
        const names = [];
        data[key].map((item) => {
          const name = this.getNameById(item, this.dataFields[key][0]);
          if (name) {
            names.push(name);
          } else if (item.hasOwnProperty('name')) {
            names.push(item.name);
          }
        });
        return names.join(', ');
      }
    },
    deleteItem(item) {
      this.toggleCRUDMode(null);
      this.alertAction(this.deleteRequest, 'delete_action_warning', item);
    },
    deleteRequest(item) {
      // Send delete request to firestore if external resource
      if (this.dataFields.externalResource) {
        this.externalDeleteRequest(item);
      } else {
        // Normal api request to database
        HTTP.delete(`api/${this.param}/${item[this.itemIdName]}`)
          .then(() => {
            // Remove the item from the table on success
            this.keywords = '';
            this.updateFirestore(
              this.param,
              item[this.itemIdName],
              item.name,
              'delete',
            );
          })
          .catch((err) => {
            const message = err.response.data.message
              ? err.response.data.message
              : this.labels.error_deleting + this.itemIdName;
            this.sweetAlert('error', message, timer);
          });
      }
    },
    async externalDeleteRequest(item) {
      const result = await CRUDDelete(this.param, item.id);

      if (result) {
        this.keywords = '';
        this.updateFirestore(this.param, item.id, item.name, 'delete');
      }
    },
    getNameById(id, type) {
      const idName = this.getCRUDName(type);
      const match = this.crudData[type].filter((item) => item[idName] === id);
      // If there is a match we return the result name
      if (match.length) {
        return match[0].name;
      }
      return null;
    },
    columnHeader(key) {
      if (
        this.dataFields.hasOwnProperty('custom_titles')
        && this.dataFields.custom_titles[key]
      ) {
        return this.labels[this.dataFields.custom_titles[key]];
      }
      return this.labels[key];
    },
    resourceSwitch(resource) {
      this.param = resource;
      this.keywords = '';
      this.toggleCRUDMode(null);
      this['products/setFormModalData'](null);
      this['products/productSegmentAction']({ index: null });
    },
    segmentationHasChildren(segId) {
      return this.crudData.segmentations.filter(
        (seg) => seg.segmentation_parent === segId,
      ).length;
    },
    canDeleteCRUD(data) {
      return this.param === 'segmentations' ? !data.hasChildren : true;
    },
  },
  created() {
    // Get the param name for request
    this.param = this.$route.params.name;
  },
};
</script>

<style>
@import "../../../theme/default/dist/demo7/assets/vendors/custom/datatables/datatables.bundle.css";

table.sticky th {
  position: sticky;
  top: 0;
}
.table-btn {
  width: 30px;
  height: 30px;
}
.table-head {
  z-index: 100;
}

.delete-disabled {
  display: contents;
}

.delete-disabled:hover > span {
  display: inline;
}

.custom-tooltip {
  position: absolute;
  display: none;
  right: 10px;
  margin-bottom: 2px;
  max-width: 200px;
  white-space: normal !important;
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CRUDs/DataTable.vue